module.exports = __webpack_public_path__ + "static/media/downarrow.0d0d24d3.svg";